import HomePage from "./pages/HomePage";
import "./App.css";

export default function App(): JSX.Element {
  return <HomePage />;
}
